export default {
    fixedAttrs: [],
    extAttrs: [],
};
